"use client";

import type { YnsComponentForm } from "../types";
import type { ChildrenStoreBuilderConfigFactory } from "./config";

export const ChildrenForm: YnsComponentForm<typeof ChildrenStoreBuilderConfigFactory> = () => {
	return (
		<div className="p-4 text-center text-gray-500">
			<p className="text-sm mb-2">Global settings have been moved!</p>
			<p className="text-xs">
				Typography, colors, and layout settings are now available in the <strong>Global Settings</strong>{" "}
				section. Click on the <strong>Settings</strong> icon in the sidebar to access them.
			</p>
		</div>
	);
};
